import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/announcements`;

export const getAnnouncementList = async () => {
    const response = await axios.get(API_BASE_URL);
    return response.data;
};

export const getAnnouncement = async (announcementId) => {
    const response = await axios.get(`${API_BASE_URL}/${announcementId}`);
    return response.data;
};